export default {
  title: {
    en: 'Great! You\'ve successfully changed your order frequency',
  },
  text: {
    en: 'We\'d love your feedback! Please take a moment to let us know why you changed your subscription frequency.',
  },
  submitButton: {
    en: 'Submit',
  },
}
